import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    ActionType,
    WidthMode,
} from "../services/types/ComponentTypes";

export const screen_174_proforma_invoice_summary: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        fabAction: {
            type: "add",
            screenId: "175",
            action: "modulev1/proforma_invoice_add",
        },
        title: "Proforma Invoice",
        style: {
            backgroundColor: "#F9FAFB",
        },
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                    borderRadius: 12,
                    padding: 16,
                },
                childComponents: [
                    {
                        componentType: LayoutTypes.GROUP,
                        style: {
                            direction: FlexDirection.ROW,
                            marginBottom: 16,
                        },
                        childComponents: [
                            {
                                componentType: ComponentType.BUTTON,
                                Label: "Back To Inspection",
                                onPressAction: "navigate_103",
                                style: {
                                    backgroundColor: "var(--primary-green)",
                                    textColor: "#FFFFFF",
                                    widthMode: WidthMode.WRAP,
                                },
                            },
                        ],
                    },
                    {
                        componentType: ComponentType.SUMMARY_LIST,
                        BindValue: "grid_invoice",
                        titleValue: "Proforma Invoice",
                        TableName: "service_invoice",
                        style: {
                            maxHeight: "calc(100vh - 350px)",
                        },
                        SummeryActions: [
                              {
                                Action: {
                                    Action: "Navigate",
                                    Navigate: "modulev1/proforma_invoice_add",
                                },
                                ActionType: ActionType.EDIT,
                                ScreenId: "175",
                                tooltip: "Edit"
                            },
                            {
                                Action: {
                                    Action: "PDF",
                                    Settings: "proforma_invoice_pdf_view"
                                },
                                ActionType: ActionType.PDF_DOWNLOAD,
                                ScreenId: "proforma_invoice_pdf_view",
                                tooltip: "View PDF"
                            }
                          
                        ],
                        Form: {
                            Name: "Proforma_invoice",
                            TableName: "service_invoice",
                            DisplayName: "Proforma_invoice",
                            View: "view_proforma_invoice_summary",
                            Fields: [
                                {
                                    IncludeLabel: true,
                                    Label: "Date",
                                    IsMandatory: false,
                                    BindValue: "txt_date",
                                    Json_Attribute: "invoice_date",
                                    componentType: ComponentType.DATE_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Invoice No.",
                                    BindValue: "txt_invoice_no",
                                    Json_Attribute: "invoice_no",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Jobcard no.",
                                    BindValue: "jobcard_no",
                                    Json_Attribute: "jobcard_no",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Customer name",
                                    BindValue: "customername",
                                    Json_Attribute: "customer_name",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Total amount",
                                    BindValue: "txt_amount",
                                    Json_Attribute: "amount",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                            ],
                        },
                    },
                ],
            },
        ],
    },
];
